import * as React from 'react';
import { containerFactory } from 'app/infrastructure/redux/index';
import { headerTranslation } from './constants';
import { STATE } from 'app/constants';
import { Link } from 'react-router-dom';
import { DesktopNav } from './components/desktop-nav';
import { MobileNav } from './components/mobile-nav';
import { HeaderProps } from './types';
import styles from './header.scss';
import { ShellState } from 'app/types-shared';
import { actionCreators as shellActions } from 'app/shell/default/actions';

export class HeaderComponent extends React.Component<HeaderProps, any> {

  public static statePath: string = STATE.app;

  public render() {
    const {print, fixedHeader} = this.props;

    return !print && (
      <header className={styles.header}>
        <nav className={`navbar navbar-inverse main-nav ${styles.navigation} ${fixedHeader ? styles.fix : ''}`}>
          <div className="container main-grid">
            <div className={styles.navbarWrapper}>
              <Link to="/" className={`brand-name ${styles.brand}`} >
                {this.props.translation.title}
              </Link>
              <DesktopNav {...this.props} />
            </div>
          </div>
          <MobileNav {...this.props} />
        </nav>
      </header>
    );
  }
}

const selectors = {
    helpUrl: (state: ShellState) => state && state.helpUrl,
    print: (_, props: HeaderProps) => (Object.keys(props.router.location.pathname) as any).includes('print'),
    messagesToUser: (state: ShellState) => state && state.messagesToUser,
    fixedHeader: (state: ShellState, props: HeaderProps) => state.fixedHeader,
    manageSurveysUrl: (state: ShellState) => state && state.manageSurveysUrl
};

const container = containerFactory<HeaderProps>(
  HeaderComponent,
  shellActions,
  selectors,
  headerTranslation);

export { container as Header };
